import { render } from "./WangEditor.vue?vue&type=template&id=38b39036"
import script from "./WangEditor.vue?vue&type=script&lang=js"
export * from "./WangEditor.vue?vue&type=script&lang=js"

import "./WangEditor.vue?vue&type=style&index=0&id=38b39036&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__